import { render, staticRenderFns } from "./CreditClassSave.vue?vue&type=template&id=b45c95fe&"
import script from "./CreditClassSave.vue?vue&type=script&lang=js&"
export * from "./CreditClassSave.vue?vue&type=script&lang=js&"
import style0 from "./CreditClassSave.vue?vue&type=style&index=0&id=b45c95fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports